import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // height: 400,
    // height: 600,
    width: '100%',
    maxWidth: '900px',
    backgroundColor: theme.palette.background.paper
  }
}));

export default function UserTab({ userTabIndex, setUserTabIndex }) {
  const classes = useStyles();

  const handleChange = (event, newValue) => {
    setUserTabIndex(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={userTabIndex}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <Tab label="General" {...a11yProps(0)} />
          <Tab label="Super Admin" {...a11yProps(1)} />
          <Tab label="Accounting" {...a11yProps(2)} />
          <Tab label="Qualification" {...a11yProps(3)} />
          <Tab label="Uniform" {...a11yProps(4)} />
        </Tabs>
      </AppBar>
    </div>
  );
}

UserTab.propTypes = {
  userTabIndex: PropTypes.any,
  setUserTabIndex: PropTypes.func
};
